import React from 'react';

import { KeyboardArrowDown as BaseKeyboardArrowDownIcon } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  Typography
} from '@mui/material';



const KeyboardArrowDownIcon = styled(BaseKeyboardArrowDownIcon)(({ theme }) => ({
  color: theme.palette.primary.main
}));

const SummaryText = styled(Typography)({
  color: '#1E3949',
  fontSize: 14,
  fontWeight: 500
});

interface IProps {
  title: string;
  isExpanded: boolean;
  children?: React.ReactNode | React.ReactNode[];

  onExpand?: (expanded: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Accordion
      style={{ textAlign: 'start' }}
      disableGutters
      onChange={(_, expanded) => props.onExpand ? props.onExpand(expanded) : undefined}
      expanded={props.isExpanded}
    >
      <AccordionSummary expandIcon={<KeyboardArrowDownIcon />}>
        <SummaryText>{props.title}</SummaryText>
      </AccordionSummary>

      <AccordionDetails>{props.children}</AccordionDetails>
    </Accordion>
  );
};
